/**
 * Created by Ivan on 10.08.2026
 */

const StickersBookStartTutorial2 = function () {
    return new TutorialScenario(StickersBookStartTutorial2.NAME, {
        listSteps: StickersBookStartTutorial2.listSteps,

        isAvailable: function () {
            return false;
        }
    });
};

StickersBookStartTutorial2.listSteps = function () {
    const getTarget = (icons) => icons.find((icon) => icon.collection.hasAttention())
        || icons.find((icon) => icon.collection.getOpenedStickersAmount(true) > 0)
        || icons[0];

    const steps = [
        {
            onStart: function () {
                cleverapps.focusManager.display({
                    focus: "StickersBookCollectionClickTutorial",
                    stack: true,
                    actions: [
                        (f) => {
                            this.releaseFocus = f;

                            const stickersBookItem = cleverapps.toolbar.getItem(ToolbarItem.STICKERS_BOOK2.type);
                            const view = stickersBookItem.onGetView();

                            if (view && !cleverapps.focusManager.isHiddenByDefault("toolbar")) {
                                cleverapps.focusManager.showControlsWhileFocused("toolbar");

                                cleverapps.forces.create(view, { finger: true, shadow: false }, {
                                    importantNodes: [ComponentUtils.findChildByName(cleverapps.Scenes.GetRunningScene(), "toolbar")],
                                    onSkip: () => cleverapps.tutorial.skip()
                                });
                            } else {
                                cleverapps.eventBus.trigger("stickers2_book_entry_force");
                            }

                            cleverapps.tutorial.on("stickers2_book_toolbar_item_clicked", f, this);
                        }
                    ]
                });

                cleverapps.tutorial.on("window_shown", () => this.finish(), this);
            },

            onFinish: function () {
                if (this.releaseFocus) {
                    this.releaseFocus();
                }
                cleverapps.tutorial.startNextStep();
            }
        },
        {
            onStart: function () {
                const stickersBookWindow = cleverapps.focusManager.currentWindow();

                if (!stickersBookWindow.icons) {
                    this.finish();
                    return;
                }
                cleverapps.focusManager.setEventNodes([]);

                stickersBookWindow.scroll.scrollTo(stickersBookWindow.icons[stickersBookWindow.icons.length - 1], 0);
                cleverapps.timeouts.setTimeout(() => {
                    const target = getTarget(stickersBookWindow.icons);
                    stickersBookWindow.scroll.scrollTo(target, 0.5, { callback: this.finish.bind(this) });
                }, 500);
            },

            onFinish: function () {
                cleverapps.tutorial.startNextStep();
            }
        },
        {
            onStart: function () {
                const createForce = () => {
                    const stickersBookWindow = cleverapps.focusManager.currentWindow();
                    const helpButton = stickersBookWindow && (stickersBookWindow.helpButton || stickersBookWindow.windowTitle && stickersBookWindow.windowTitle.helpButton);

                    if (!helpButton) {
                        this.force = undefined;
                        return;
                    }

                    this.force = cleverapps.forces.create(helpButton, { finger: true, shadow: false }, {
                        onSkip: () => cleverapps.tutorial.skip()
                    });
                };

                createForce();
                cleverapps.tutorial.on("window_shown", () => {
                    if (this.force) {
                        cleverapps.forces.closeRunningForce();
                        this.force = undefined;
                    }
                }, this);
                cleverapps.tutorial.on("onResize", () => {
                    if (this.force) {
                        this.force.close();
                        createForce();
                    }
                }, this);
                cleverapps.tutorial.on("window_closed", this.finish.bind(this), this);
            },

            onFinish: function () {
                cleverapps.tutorial.startNextStep();
            }
        },
        {
            onStart: function () {
                const stickersBookWindow = cleverapps.focusManager.currentWindow();

                if (!stickersBookWindow.icons) {
                    this.finish();
                    return;
                }

                const createForce = () => {
                    const stickersBookWindow = cleverapps.focusManager.currentWindow();
                    const icons = stickersBookWindow.icons;
                    this.target = getTarget(icons);
                    stickersBookWindow.scroll.scrollTo(this.target, 0);
                    this.target.setPrizeBarTooltipEnabled(false);
                    this.force = cleverapps.forces.create(this.target, { finger: true }, {
                        onSkip: () => cleverapps.tutorial.skip()
                    });
                };

                createForce();
                cleverapps.tutorial.on("onResize", () => {
                    this.force.close();
                    createForce();
                }, this);
                cleverapps.tutorial.on("stickers2_collection_icon_clicked", () => {
                    this.target.setPrizeBarTooltipEnabled(true);
                    this.finish();
                }, this);
            },

            onFinish: function () {
                cleverapps.tutorial.startNextStep();
            }
        }
    ];

    return steps.map((step) => new TutorialStep(step));
};

StickersBookStartTutorial2.NAME = "sticker2_book_start_tutorial";
